import { Dimensions } from '@/modules/store/models/Dimensions';
import { Image } from '@/modules/store/models/Image';
import { NetContent } from '@/modules/store/models/NetContent';
import { Price } from '@/modules/store/models/Price';
import type { Product } from '@/modules/store/models/Product';
import { Promotion } from '@/modules/store/models/Promotion';
import { Status } from '@/modules/store/models/Status';
import { Supplier } from '@/modules/store/models/Supplier';

export enum SkuAssociation {
  PRICES = 'prices',
  PRODUCT = 'product',
  SUPPLIER = 'supplier',
  PROMOTIONS = 'promotions',
  ALL = 'all',
}

export interface Sku {
  id: string;
  code: string;
  productId: string;
  supplierId: string;
  externalCode: string;
  name: string;
  description: string;
  dimensions?: Dimensions;
  netContent?: NetContent;
  quantity?: number;
  moq?: number;
  images: Image[];
  customData?: { [key: string]: string };
  status: Status;
  product?: Product;
  prices?: Price[];
  supplier?: Supplier;
  promotions?: Promotion[];
  createdAt: Date;
  createdByStoreId?: string;
}

export interface Skus {
  items: Sku[];
  totalCount?: number;
  estimatedTotalCount?: number;
}
